import * as Yup from "yup";

const validationSchemaLogin = Yup.object().shape({
	username: Yup.string().required().label("Username"),
	password: Yup.string().required().label("Password"),
});

export { validationSchemaLogin };
